/* eslint-disable react/jsx-props-no-spreading */
import { format, isValid } from 'date-fns';
import React from 'react';

import InputFieldDate from '@/components/InputFieldDate';
import InputFieldTime from '@/components/InputFieldTime';

import InputFieldSelect from '@/components/InputFieldSelect';
import {
  ArtifactFieldWidget,
  ArtifactWidgetProps,
} from '../components/ArtifactForm/ArtifactForm.types';

export const AgendamentoDateWidget: ArtifactFieldWidget = ({
  control: { field, fieldState },
  field: formField,
  fieldState: artifactFieldState,
}) => {
  const dateValue = typeof field.value === 'string' ? field.value : '';

  return (
    <InputFieldDate
      name={formField.name}
      title={artifactFieldState.label}
      value={dateValue}
      disabled={artifactFieldState.disabled}
      readOnly={formField.readOnly}
      error={fieldState.error?.message}
      onChangeDate={date => {
        if (!date || !isValid(date)) {
          field.onChange('');
          return;
        }

        field.onChange(format(date, 'yyyy-MM-dd'));
      }}
    />
  );
};

export const AgendamentoTimeWidget: ArtifactFieldWidget = ({
  control: { field, fieldState },
  field: formField,
  fieldState: artifactFieldState,
}) => {
  const timeValue = typeof field.value === 'string' ? field.value : '';

  return (
    <InputFieldTime
      name={formField.name}
      title={artifactFieldState.label}
      value={timeValue}
      disabled={artifactFieldState.disabled}
      readOnly={formField.readOnly}
      error={fieldState.error?.message}
      onChangeTime={value => field.onChange(value || '')}
    />
  );
};

export const AgendamentoSelectDateWidget: React.ComponentType<
  ArtifactWidgetProps & { options: { label: string; value: string }[] }
> = ({
  control: { field, fieldState: controlFieldState },
  field: formField,
  fieldState,
  options,
}) => {
  return (
    <InputFieldSelect
      title={fieldState.label}
      options={options}
      defaultValue={options[0]?.value}
      onChange={value => field.onChange(value)}
      disabled={fieldState.disabled}
      readOnly={formField.readOnly}
      value={field.value}
      name={formField.name}
      error={controlFieldState.error?.message}
    />
  );
};
